import React, { Component } from 'react';
import { ErrorNotFound } from '../Errors';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { getProtectedRoute } from 'helpers/routeHelper';
import { getLocalUserData } from 'Redux/actions/LoginActions';
import { getLocalSettingsTableData } from 'Redux/actions/SettingsTableActions';
import { toggleIsMobileView } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import routes from './routes';

import LoaderModal from 'organisms/LoaderModal';
import ModalPage from 'templates/ModalPage';

class App extends Component {
  componentDidMount() {
    this.props.toggleIsMobileView(window.screen.width);
    this.props.getLocalUserData();
    this.props.getLocalSettingsTableData();

    // listen to display resizing
    window.addEventListener('resize', () => {
      this.props.toggleIsMobileView(window.screen.width)
    })
  }

  render() {
    const { viewState: { isLoading } } = this.props
    return (
      <BrowserRouter>
        {/* provide the loader modal */}
        <ModalPage
          isOpen={isLoading}
          fnSwitch={null}
          size={'83px'}
          topmost={true}
          contentChild={
            <LoaderModal />
          }
        />
        {/* provide the switch router for main routes */}
        <Switch>
          {routes.map((r, i) =>
            <Route
              key={i}
              path={r.path}
              exact={r.exact}
              render={props => getProtectedRoute(r, props)}
            />
          )}
          {/* one route to catch any invalid routes */}
          <Route component={ErrorNotFound} />
        </Switch>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    viewState: state.viewState
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getLocalUserData,
      getLocalSettingsTableData,
      toggleIsMobileView
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);